module.exports = __webpack_public_path__ + "static/media/offlineAdminCreate.e2cf1b43.svg";